module.exports = __webpack_public_path__ + "static/media/HAUX_TRAINING_GUIAS_GUIA_GERAL.49e40ec5.pdf";